import React from 'react';

// Component that provides transition styles for all code labels
// Renders once at the CodeNestedDisplay level instead of for each code
const CodeTransitionStyles = () => (
  <style type="text/css">{`
    /* Selection transition - from ultra light grey to light grey */
    .code-label-body[data-transition="select"] {
      animation: fadeToSelected 500ms ease-out;
    }
    
    /* Deselection transition - from light grey to ultra light grey */
    .code-label-body[data-transition="deselect"] {
      animation: fadeFromSelected 500ms ease-out;
    }
    
    /* Disabled search highlight - from yellow to ultra light grey */
    .code-label-body[data-transition="search-disabled"] {
      animation: fadeFromYellow 1.5s ease-out;
    }
    
    /* Keyframe animations */
    
    /* Selection: ultra light grey -> light grey */
    @keyframes fadeToSelected {
      from { 
        background-color: #F0F0F0; /* ULTRA_LIGHT_GREY */
      }
      to { 
        background-color: #979797; /* LIGHT_GREY */
      }
    }
    
    /* Deselection: light grey -> ultra light grey */
    @keyframes fadeFromSelected {
      from { 
        background-color: #979797; /* LIGHT_GREY */
      }
      to { 
        background-color: #F0F0F0; /* ULTRA_LIGHT_GREY */
      }
    }
    
    /* Disabled search: yellow -> ultra light grey with 1s delay */
    @keyframes fadeFromYellow {
      0% { 
        background-color: #FFF8E3; /* YELLOW */
      }
      66% { 
        background-color: #FFF8E3; /* YELLOW - hold for 1s */
      }
      100% { 
        background-color: #F0F0F0; /* ULTRA_LIGHT_GREY */
      }
    }
    
    /* Override transitions during drag operations to prevent unwanted animations */
    .code-label-body.dragging {
      transition: none;
      animation: none;
    }
  `}</style>
);

export default CodeTransitionStyles;